import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
// import { Inboundcall } from './components';

const Inboundcall = lazy(()=> import(/* webpackChunkName: "inboundcall" */ './components/Inboundcall'))

const routes = () => (
  <PrivateRoute exact path="/inboundcall" component={Inboundcall} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/inboundcall/Inboundcall/routes.js